import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { DashboardService } from 'src/app/providers/dashboard/dashboard.service';
import { EmployeeService } from 'src/app/providers/employee/employee.service';
import { PoliciesService } from 'src/app/providers/policy/policies.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
import Swal from 'sweetalert2';

declare let $: any;
@Component({
  selector: 'app-mediclaims',
  templateUrl: './mediclaims.component.html',
  styleUrls: ['./mediclaims.component.scss'],
})
export class MediclaimsComponent implements OnInit {
  public result: any = [];
  familyForm: FormGroup;
  empRelation: any;
  empFamList: any;
  Logs: any;
  dynamicHeader: any;
  submitted: boolean;
  loading: boolean;
  userDetails: any;
  empID: any;
  disbaled: any;
  disTrue: boolean;
  Type: any = 0;
  maxDob: any = '';
  content: any = [];
  mediclaimDocs: any = [];
  constructor(
    private formBuilder: FormBuilder,
    private notifyService: NotificationService,
    private empServe: EmployeeService,
    private dashboardServe: DashboardService,
    private polcyServ: PoliciesService
  ) {}

  ngOnInit(): void {
    this.getEmpRelation();
    this.familyFormField();
    this.getloggedUserforMediclain();
    this.mediclaimData({ tpcID: '' }, 4);
    this.getPageContent();
  }

  mediclaimData(data, catID): void {
    // tslint:disable-next-line: deprecation
    this.polcyServ.getsbTopicData(data, catID).subscribe((res) => {
      if (res.status) {
        this.mediclaimDocs = res.data;
      } else {
        this.notifyService.showInfo(res.msg, 'Info!');
      }
    });
  }

  getloggedUserforMediclain(): void {
    this.dashboardServe.getLoggedInEmpDetails().subscribe((res) => {
      this.result = res;
      this.userDetails = this.result.data;
      this.empID = this.result.data.id;
      this.disbaled = this.result.data.is_mediclaim_submit;
      if (this.disbaled == 1) {
        this.disTrue = true;
      } else {
        this.disTrue = false;
      }
      console.log(this.userDetails);
      console.log(this.disbaled);
      this.getEmpFamDeatils();
    });
  }
  // tslint:disable-next-line: typedef
  get famErrorMsg() {
    return this.familyForm.controls;
  }
  get famType() {
    return this.familyForm.get('dpndt_rln_id').value;
  }

  getEmpRelation(): void {
    this.empServe.getEmpRelationMed().subscribe(
      (res) => {
        this.result = res;
        this.empRelation = this.result.data;
      },
      (err) => {}
    );
  }
  getEmpFamDeatils(): void {
    this.empServe.getEmpFamMediclaim(this.empID).subscribe(
      (res) => {
        this.result = res;
        this.empFamList = this.result.data;
        this.maxDob = this.result.dob;
        this.Type = this.result.user_type;
        this.Logs = this.result.famlogs;
        console.log('logs', this.Logs);
      },
      (err) => {}
    );
  }
  familyFormField(): void {
    this.familyForm = new FormGroup({
      family_id: new FormControl(''),
      dpndt_name: new FormControl('', Validators.required),
      dpndt_rln_id: new FormControl('', Validators.required),
      dpndnt_cont: new FormControl(''),
      dpndnt_email: new FormControl(''),
      empId: new FormControl(''),
      cover_med: new FormControl(''),
      fam_dob: new FormControl(''),
    });
  }
  open_family_modal(id, header): void {
    this.dynamicHeader = header;
    this.familyForm.patchValue({
      empId: this.empID,
    });
    $(id).modal({ backdrop: 'static', keyboard: false });
  }
  onSubmitFamily(): void {
    this.submitted = true;
    if (this.familyForm.invalid) {
      return;
    }
    this.loading = true;
    this.empServe.addEmpFam(this.familyForm.value).subscribe(
      (res) => {
        console.log(res);
        this.submitted = false;
        this.loading = false;
        this.result = res;
        if (this.result.status === true) {
          this.notifyService.showSuccess(this.result.msg, 'Success');
          this.familyForm.reset();
          this.getEmpFamDeatils();
          $('#add_family_form').modal('hide');
        } else {
          this.notifyService.showError(this.result.msg, 'Error!');
        }
      },
      (err) => {
        this.submitted = false;
        this.loading = false;
        this.notifyService.showError(err.error.msg, 'Error!');
      }
    );
  }
  onResetFamily(): void {
    this.submitted = false;
    this.familyForm.reset();
  }
  editFamily(famId, header): void {
    this.dynamicHeader = header;
    this.empServe.editEmpFam(famId).subscribe(
      (res) => {
        this.result = res;
        console.log(this.result);
        this.familyForm.patchValue({
          family_id: this.result.data.dpndt_id,
          dpndt_name: this.result.data.dpndt_name,
          dpndt_rln_id: this.result.data.dpndt_rln_id,
          dpndnt_cont: this.result.data.dpndnt_cont1,
          dpndnt_email: this.result.data.dpndnt_email1,
          empId: this.result.data.user_id,
          cover_fam: this.result.data.is_under_mediclaim,
          dob: this.result.data.dpndt_dob,
        });
        $('#add_family_form').modal({ backdrop: 'static', keyboard: false });
      },
      (err) => {}
    );
  }

  freezeFamilyDetails(): void {
    Swal.fire({
      title: 'Are you sure, You want to freeze the details ?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No, ',
    }).then((result) => {
      if (result.value) {
        const params = {
          user_id: this.empID,
          is_med_submit: '1',
        };
        console.log(params);
        this.empServe.freezeFamily(params).subscribe(
          (res) => {
            this.result = res;
            console.log(this.result);
            if (this.result.status) {
              this.notifyService.showSuccess(this.result.msg, 'Success!');
            } else {
              this.notifyService.showWarning(this.result.msg, 'Error!');
            }
            this.getloggedUserforMediclain();
          },
          (err) => {
            this.notifyService.showError('Internal server error', 'Error!');
          }
        );
      } else {
      }
    });
  }

  getPageContent(): void {
    this.dashboardServe.getEmpAssistance().subscribe((res) => {
      this.content = res.data;
    });
  }
}
